import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { TelnyxVoiceIntegration, TwilioVoiceIntegration } from '@/shared/types/integration';

import CardBase from '../../Components/CardBase';

/** Sets voice_psid_field: where channels reads the caller of an inbound SIP call. */
const SipCaller = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<TwilioVoiceIntegration | TelnyxVoiceIntegration>();

  return (
    <CardBase title={t('integrations.voice_common.sip_caller.title')}>
      <FormField
        control={control}
        name="config.voice_psid_field"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('integrations.voice_common.sip_caller.label')}</FormLabel>
            <FormControl>
              <Input
                {...field}
                value={field.value ?? ''}
                type="text"
                placeholder={t('integrations.voice_common.sip_caller.placeholder')}
                onChange={(e) => field.onChange(e.target.value.trim())}
              />
            </FormControl>
            <FormDescription>
              {t('integrations.voice_common.sip_caller.description')}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </CardBase>
  );
};

export default SipCaller;
